import React from 'react';
import Broucher from '../Broucher/Broucher';
import Gallery from '../Gallery/Gallery';
import Broucherfirst from '../Broucherfirst/Broucherfirst';
import KnowMoreFirstPage from '../KnowMoreFirstPage/KnowMoreFirstPage';
const KnowMore = () => {
  return (
    <div>
   <KnowMoreFirstPage />
   
    </div>
  );
};
export default KnowMore;